import { HBBannerBaseProps } from '../HBBanner/HBBanner.types';

type Props = Pick<
    HBBannerBaseProps,
    'primaryAction' | 'secondaryAction' | 'actionsTheme'
>;

export function useValidateBanner({
    actionsTheme,
    primaryAction,
    secondaryAction
}: Props) {
    let allowed = true;
    let error = '';

    if (!primaryAction && secondaryAction) {
        allowed = false;
        error =
            'You have to set primary action before setting a secondary action';
    }

    if (secondaryAction && actionsTheme === 'button-link') {
        allowed = false;
        error =
            "You can't use the button-link as the main action in case you have more then one action";
    }

    if (!allowed) {
        throw new Error(error);
    }
}
